import React from "react";
import { motion, useInView, animate } from "framer-motion";

export default function Counter({ to = 100, duration = 1.6, prefix = "", suffix = "" }) {
  const ref = React.useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const [value, setValue] = React.useState(0);

  React.useEffect(() => {
    if (!inView) return;
    const controls = animate(0, to, {
      duration,
      ease: [0.22, 1, 0.36, 1],
      onUpdate(v) { setValue(Math.round(v)); },
    });
    return () => controls.stop();
  }, [inView, to, duration]);

  return <span ref={ref}>{prefix}{value.toLocaleString()}{suffix}</span>;
}
